import { useState } from 'react';
import { Link } from 'react-router-dom';
import { logisticsApi, type RateQuote } from '../../api/logistics';

export function RateComparisonPage() {
  const [quotes, setQuotes] = useState<RateQuote[]>([]);
  const [error, setError] = useState('');
  const [origin, setOrigin] = useState('110001');
  const [dest, setDest] = useState('400001');
  const [weight, setWeight] = useState('2');

  async function compare() {
    setError('');
    try {
      setQuotes(await logisticsApi.rates({
        origin_pincode: origin, dest_pincode: dest, weight: parseFloat(weight),
      }));
    } catch (e) {
      setError(String(e));
    }
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/logistics" className="text-sm text-slate-600 hover:underline">← Logistics hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Rate comparison</h1>
      <div className="mt-4 flex flex-wrap gap-2">
        <input value={origin} onChange={(e) => setOrigin(e.target.value)} placeholder="Origin" className="rounded border px-2 py-1 text-sm" />
        <input value={dest} onChange={(e) => setDest(e.target.value)} placeholder="Dest" className="rounded border px-2 py-1 text-sm" />
        <input value={weight} onChange={(e) => setWeight(e.target.value)} placeholder="Weight kg" className="rounded border px-2 py-1 text-sm w-24" />
        <button type="button" onClick={() => void compare()} className="rounded bg-slate-900 px-3 py-1 text-sm text-white">Compare</button>
      </div>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
      <table className="mt-6 min-w-full text-left text-sm border rounded-xl overflow-hidden">
        <thead className="bg-slate-50"><tr>
          <th className="p-3">Carrier</th><th className="p-3">Rate</th><th className="p-3">Days</th><th className="p-3">SLA</th>
        </tr></thead>
        <tbody>
          {quotes.map((q) => (
            <tr key={q.carrier_code} className="border-t">
              <td className="p-3">{q.carrier_name}</td>
              <td className="p-3">{q.currency} {q.total_rate.toFixed(2)}</td>
              <td className="p-3">{q.estimated_days}</td>
              <td className="p-3">{(q.sla_score * 100).toFixed(0)}%</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
